module.exports = __webpack_public_path__ + "media/images/admin/icons/dollar-sign-8d9a6f938731fde21207ac6851ae5fcb.svg";